module.exports = __webpack_public_path__ + "img/cloud_black.85de4b2c.svg";